import { useSyncExternalStore } from 'react';

let isDirty = false;
const listeners = new Set<(isDirty: boolean) => void>();

export const dirtyGuardStore = {
  getSnapshot: () => isDirty,
  subscribe: (listener: () => void) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
  setSettingsDirty: (dirty: boolean) => {
    isDirty = dirty;
    listeners.forEach(l => l(isDirty));
  }
};

export const useDirtyGuard = () => {
  const isSettingsDirty = useSyncExternalStore(
    dirtyGuardStore.subscribe,
    dirtyGuardStore.getSnapshot
  );
  
  return {
    isSettingsDirty,
    setSettingsDirty: dirtyGuardStore.setSettingsDirty
  };
};

export const setSettingsDirty = (dirty: boolean) => 
  dirtyGuardStore.setSettingsDirty(dirty);

export const getIsSettingsDirty = () => isDirty;
